import { BaseValidationRule, IValidateable } from '@aurelia/validation';

export class ValidYearPropertyRule extends BaseValidationRule {
  public constructor(private propertyName: string) {
    super();
  }

  public execute(value: any, _object?: IValidateable): boolean {
    const d = new Date();
    const currentYear = d.getFullYear().toString().substr(-2);
    const month: any = d.getMonth() + 1;
    const currentMonthFormatted = month.length > 1 ? month : "0" + month;

    if (_object.cardExpiryMonth < currentMonthFormatted) {
      if (value <= currentYear) {
        return false;
      }
    }
    return true;
  }
}
